import { STATUSES } from './statuses';
import * as modals from './modals';

export const massActions = [
  {
    title: 'Change status',
    accessKey: 'change_statuses',
    value: 'CHANGE_STATUSES',
    subMenu: [
      {
        title: STATUSES.ACTIVE.title,
        value: STATUSES.ACTIVE.code,
        data: {
          id: STATUSES.ACTIVE.id,
        },
      },
      {
        title: STATUSES.PAUSE.title,
        value: STATUSES.PAUSE.code,
        data: {
          id: STATUSES.PAUSE.id,
        },
      },
      {
        title: STATUSES.FINISHED.title,
        value: STATUSES.FINISHED.code,
        data: {
          id: STATUSES.FINISHED.id,
        },
      },
    ],
  },
]

export const RESEND = 'RESEND';

export const accessActions = {
  can_edit_expiry: {
    id: 'EDIT_EXPIRY',
    title: 'Edit expiry',
    defActionName: 'can_edit_expiry',
  },
  can_make_active: {
    id: STATUSES.ACTIVE.code,
    status: true,
    title: 'Active',
    defActionName: 'can_make_active',
  },
  can_make_completed: {
    id: STATUSES.FINISHED.code,
    status: true,
    title: 'Completed',
    defActionName: 'can_make_completed',
  },
  can_make_paused: {
    id: STATUSES.PAUSE.code,
    status: true,
    title: 'Paused',
    defActionName: 'can_make_paused',
  },
  can_make_canceled: {
    id: STATUSES.STOPPED.code,
    title: 'Cancel',
    defActionName: 'can_make_canceled',
  },
  can_view_details: {
    id: modals.DETAILS,
    title: 'Details',
    defActionName: 'can_view_details',
  },
  can_view_fail_details: {
    id: modals.FAIL_DETAILS,
    title: 'Fail details',
    defActionName: 'can_view_fail_details',
  },
  can_view_error_details: {
    id: modals.ERROR_DETAILS,
    title: 'Error details',
    defActionName: 'can_view_error_details',
  },
  can_make_resend: {
    id: RESEND,
    title: 'Resend subscription',
    defActionName: 'can_make_resend',
  },
}
